<div class="d-flex align-items-center justify-content-center empty-state">
  <div class="py-2 w-100 h-100 d-flex flex-column align-items-center justify-content-center gap-3">
    <img src="../../../../assets/images/no-data.svg" alt="no-content" class="empty-state-img" />
    <span class="empty-state-text">{{ placeholderText }}</span>
  </div>
</div>
